// Role generation polling functionality
// Converted from jQuery $.ajax polling

document.addEventListener('DOMContentLoaded', () => {
  // Auto-select username input if present
  const userCodeInput = document.getElementById('user_user_code')
  if (userCodeInput) {
    userCodeInput.select()
  }

  // Start polling for any roles with status="generating"
  const generatingRoles = document.querySelectorAll('[data-status="generating"]')

  generatingRoles.forEach((roleElement) => {
    const roleId = roleElement.dataset.roleId
    const statusUrl = roleElement.dataset.statusUrl

    if (statusUrl) {
      startCheckGeneratingComplete(roleId, statusUrl)
    }
  })
})

function startCheckGeneratingComplete(roleId, statusUrl) {
  setTimeout(async () => {
    try {
      const response = await fetch(statusUrl, {
        headers: { 'Accept': 'application/json' }
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()

      if (data.status === 'active') {
        // Role generation is complete, reload the demo roles container
        const allDemoRoles = document.getElementById('all-demo-roles')
        if (allDemoRoles) {
          const rolesUrl = allDemoRoles.dataset.rolesUrl
          if (rolesUrl) {
            const refreshResponse = await fetch(rolesUrl, {
              headers: { 'Accept': 'text/html' }
            })
            const html = await refreshResponse.text()
            allDemoRoles.innerHTML = html
          }
        }
      } else {
        // Role is still generating, continue polling
        startCheckGeneratingComplete(roleId, statusUrl)
      }
    } catch (error) {
      console.error(`Polling error for role ${roleId}:`, error)
      // Continue polling even on error
      startCheckGeneratingComplete(roleId, statusUrl)
    }
  }, 5000)
}
